import {Modal, notification} from 'antd'
import {ObjectInspector} from 'react-inspector'
import React from 'react'
import {bulkMarkUnprintedOrderByIds} from "../../../../../services/api/3dApi"

async function rqBulkMarkUnprinted(ids) {
    const payload = {
        ids,
    }
    const {data: response} = await bulkMarkUnprintedOrderByIds(payload)
    const {success, error, data} = response

    if (!success) {
        throw new Error(error)
    }

    return data
}

/**
 *
 * @param {Array} ids
 * @param {function} onSuccess
 * @param onReset
 */

export default function (ids, onSuccess, onReset) {
    Modal.confirm({
        title: 'Bạn chắc chắn đánh dấu chưa in các orders được chọn ?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk() {
            rqBulkMarkUnprinted(ids).then(result => {
                notification.success({
                    message: 'Đánh dấu chưa in',
                    description: <ObjectInspector data={result}/>,
                    duration: 0,
                })
                onReset()
                onSuccess()
            }).catch(err => {
                notification.error({
                    message: 'ERROR',
                    description: err.message,
                    duration: 0,
                })
            })
        }
    })
}
